require.context("../images", true);
import "src/decidim/vendor/leaflet.fullscreen";
import "src/decidim/geo/index.js";
